import { css } from '@emotion/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { ProductI } from '../../payment.types';
import { paymentFormHeaderCss } from '../checkout.styles';
import { StripeFlow } from '../payment-flow/stripe-flow/stripe-flow.component';
import { usePaypalFlow } from '../payment-flow/paypal-flow/paypal-flow.hook';
import { PaypalAuthButton } from '../payment-flow/paypal-flow/paypal-auth-button.component';
import { PaypalConfirmation } from '../payment-flow/paypal-flow/paypal-confirmation.component';

interface Props {
  className?: string;
  product: ProductI;
  submitButtonLabel: string;
  isBundleAdded: boolean;
}

export const PaymentMethods: React.FC<Props> = (props) => {
  const { className, product, submitButtonLabel, isBundleAdded } = props;
  const { t } = useTranslation();
  const { loading, step, tokenResponse, processPayment, onPaypalApprove } = usePaypalFlow({ product, isBundleAdded });

  if (step === 'billing-info' && tokenResponse) {
    return (
      <PaypalConfirmation
        className={className}
        loading={loading}
        buttonLabel={submitButtonLabel}
        onSubmit={processPayment}
        tokenResponse={tokenResponse}
      />
    );
  }

  return (
    <div className={className}>
      <p css={paymentFormHeaderCss}>{t('Enter payment details')}</p>
      <StripeFlow
        product={product}
        submitButtonLabel={submitButtonLabel}
        isBundleAdded={isBundleAdded}
        paypalButton={<PaypalAuthButton css={paypalCss} onApprove={onPaypalApprove} />}
      />
    </div>
  );
};

const paypalCss = css`
  margin-top: 8px;
`;
